import pirate_scarf from './pirate_scarf.svg';
import pirate_hat from './pirate_hat.svg';
import spaceExplorer_antennaHead from './spaceExplorer_antennaHead.svg';
import spaceExplorer_spaceHelmet from './spaceExplorer_spaceHelmet.svg';
import wizard_cap from './wizard_cap.svg';
import wizard_horns from './wizard_horns.svg';


const characterStylesAssets = [
  {
    avatar: 'wizard',
    avatarStyle: 'Wizard Horns',
    imgSrc: wizard_horns,
  },
  {
    avatar: 'wizard',
    avatarStyle: 'Wizard Cap',
    imgSrc: wizard_cap,
  },
  {
    avatar: 'space explorer',
    avatarStyle: 'Space Explorer Space Helmet',
    imgSrc: spaceExplorer_spaceHelmet,
  },
  {
    avatar: 'space explorer',
    avatarStyle: 'Space Explorer Antenna Head',
    imgSrc: spaceExplorer_antennaHead,
  },
  {
    avatar: 'pirate',
    avatarStyle: 'Pirate Hat',
    imgSrc: pirate_hat,
  },
  {
    avatar: 'pirate',
    avatarStyle: 'Pirate Scarf',
    imgSrc: pirate_scarf,
  },
]

export { characterStylesAssets }

